import { createContext } from 'react';

import Interop from './service';
const CoreInteropContext = createContext(Interop);

export { Interop as Context };
export default CoreInteropContext;
